module.exports = __webpack_public_path__ + "portal/assets/img/logo.7e0994ae.svg";